module.exports = __webpack_public_path__ + "static/media/smm_logo.589988d7.svg";